module.exports = __webpack_public_path__ + "static/media/4ece1f85-25b4-498a-ba81-248a45aa2e32.d723bab9.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/4ece1f85-25b4-498a-ba81-248a45aa2e32.jpg
// module id = 818
// module chunks = 0